require("core-js/modules/es6.object.define-property.js");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "prop-types"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes);
    global.TailSpin = mod.exports;
  }
})(this, function (exports, _react, _propTypes) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.TailSpin = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  var TailSpin = exports.TailSpin = function TailSpin(props) {
    return _react2["default"].createElement("svg", {
      width: props.width,
      height: props.height,
      viewBox: "0 0 38 38",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": props.label
    }, _react2["default"].createElement("defs", null, _react2["default"].createElement("linearGradient", {
      x1: "8.042%",
      y1: "0%",
      x2: "65.682%",
      y2: "23.865%",
      id: "a"
    }, _react2["default"].createElement("stop", {
      stopColor: props.color,
      stopOpacity: "0",
      offset: "0%"
    }), _react2["default"].createElement("stop", {
      stopColor: props.color,
      stopOpacity: ".631",
      offset: "63.146%"
    }), _react2["default"].createElement("stop", {
      stopColor: props.color,
      offset: "100%"
    }))), _react2["default"].createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, _react2["default"].createElement("g", {
      transform: "translate(1 1)"
    }, _react2["default"].createElement("path", {
      d: "M36 18c0-9.94-8.06-18-18-18",
      id: "Oval-2",
      stroke: props.color,
      strokeWidth: "2"
    }, _react2["default"].createElement("animateTransform", {
      attributeName: "transform",
      type: "rotate",
      from: "0 18 18",
      to: "360 18 18",
      dur: "0.9s",
      repeatCount: "indefinite"
    })), _react2["default"].createElement("circle", {
      fill: "#fff",
      cx: "36",
      cy: "18",
      r: props.radius
    }, _react2["default"].createElement("animateTransform", {
      attributeName: "transform",
      type: "rotate",
      from: "0 18 18",
      to: "360 18 18",
      dur: "0.9s",
      repeatCount: "indefinite"
    })))));
  };

  TailSpin.propTypes = {
    height: _propTypes2["default"].oneOfType([_propTypes2["default"].string, _propTypes2["default"].number]),
    width: _propTypes2["default"].oneOfType([_propTypes2["default"].string, _propTypes2["default"].number]),
    color: _propTypes2["default"].string,
    label: _propTypes2["default"].string,
    radius: _propTypes2["default"].number
  };
  TailSpin.defaultProps = {
    height: 80,
    width: 80,
    color: "green",
    radius: 1,
    label: "audio-loading"
  };
});